module.exports = __webpack_public_path__ + "static/specSheet-359c9ba119e60b964514077ad625b375.svg";